import type { Mission, ShiftType, WeighbridgeTiming } from '@logistech/ui-shared';

// Aligné sur l'enum MissionStatus (prisma/schema.prisma)
export const MISSION_STATUS_LABELS: Record<Mission['status'], string> = {
  DRAFT: 'Brouillon',
  SCHEDULED: 'Planifiée',
  IN_PROGRESS: 'En cours',
  COMPLETED: 'Terminée',
  CANCELLED: 'Annulée',
};

export const MISSION_STATUS_VARIANT: Record<Mission['status'], 'default' | 'secondary' | 'success' | 'warning' | 'destructive'> = {
  DRAFT: 'secondary',
  SCHEDULED: 'warning',
  IN_PROGRESS: 'default',
  COMPLETED: 'success',
  CANCELLED: 'destructive',
};

export const SHIFT_LABELS: Record<ShiftType, string> = { DAY: 'Jour', NIGHT: 'Nuit' };

export const SHIFT_BADGE_CLASS: Record<ShiftType, string> = {
  DAY: 'border-transparent bg-amber-400 text-amber-950',
  NIGHT: 'border-transparent bg-blue-900 text-white',
};

// Valeurs proposées pour Mission.cargoDesc (texte libre côté API) ; « Autre » ouvre une saisie libre
export const CARGO_TYPES = ['Bauxite', 'Alumine', 'Ciment', 'Carburant', 'Minerai de fer'] as const;

/** ISO → valeur d'un <input type="datetime-local"> (heure locale, à la minute). */
export const toLocalInput = (iso: string | Date | null | undefined) => {
  if (!iso) return '';
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
};

export const WEIGHBRIDGE_TIMING_LABELS: Record<WeighbridgeTiming, string> = {
  BEFORE_LOADING: 'Avant chargement',
  AFTER_LOADING: 'Après chargement',
  BEFORE_UNLOADING: 'Avant déchargement',
  AFTER_UNLOADING: 'Après déchargement',
};

// assertMissionOpen du missions-service : rotations saisissables seulement sur ces statuts
export const ROTATION_OPEN_STATUSES: readonly Mission['status'][] = ['SCHEDULED', 'IN_PROGRESS'];

export const fmtKg = (kg: number) => `${kg.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} kg`;
